import { gql } from '@apollo/client';

export const ALL_ACTIVITY_SERVICE_CATEGORIES = gql`
  query AllActivityServiceCategories($activityId: ID!) {
    serviceCategories: allActivityServiceCategories(activityId: $activityId) {
      id
      name
    }
  }
`;
